/**
 *
 * @param {*} array
 * @param {*} a
 */
export const array_remove = (array, a) => {
    var what,
        L = a.length,
        ax;
    while (L && array.length) {
        what = a[--L];
        while ((ax = array.indexOf(what)) !== -1) {
            array.splice(ax, 1);
        }
    }
    return array;
};

/**
 *
 */
export const browserDetails = {};

/**
 *
 * @param {*} value
 * @param {*} to
 * @param {*} from
 */
export const convertWeightTo = (value, to, from) => {
    var weightUnitMap = {
        g: 'grams',
        mg: 'milligrams',
        kg: 'kilograms',
        oz: 'ounces',
        lbs: 'pounds',
        lb: 'pounds',
    };

    var weightMap = {
        milligrams: 0.001,
        grams: 1,
        kilograms: 1000,
        ounces: 62.5,
        pounds: 1000,
    };

    if (typeof value !== 'object') {
        value = new Big(value);
    }

    // DEFAULT VALUE
    to = to === undefined ? 'grams' : to;
    from = from === undefined ? 'grams' : from;

    // GET WeightUnit ACCORDING TO weightUnitMap
    to = weightMap[to] === undefined ? weightUnitMap[to] : to;
    from = weightMap[from] === undefined ? weightUnitMap[from] : from;

    value = value.times(weightMap[from]).div(weightMap[to]);

    return value;
};

/**
 *
 * @param {*} target
 */
export const dropdown = (target) => {
    if ($('#' + target + ':visible').length === 0) {
        $('#' + target).slideDown('fast');
    } else {
        $('#' + target).slideUp('fast');
    }
};

/**
 *
 * @param {*} id
 */
export const exists = (id) => {
    return 0 < $('#' + id).length;
};

/**
 *
 */
export const generateRandom = () => {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    for (var i = 0; i < 7; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
};

/**
 *
 * @param {*} needle
 * @param {*} haystack
 */
export const in_array = (needle, haystack) => {
    for (var i = 0; i < haystack.length; i++) {
        if (haystack[i] === needle) {
            return true;
        }
    }
    return false;
};

/**
 *
 * @param {*} num
 */
export const isNumber = (num) => {
    return !isNaN(parseFloat(num)) && isFinite(num);
};

/**
 *
 * @param {*} obj
 */
export const isObjectEmpty = (obj) => {
    return typeof obj === 'object' ? Object.getOwnPropertyNames(obj).length == 0 : true;
};

/**
 *
 * @param {*} call
 */
export const launch = (call) => {
    return 'function' === typeof call ? call() : true;
};

/**
 *
 * @param {*} str
 */
export const nl2br = (str) => {
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br/>$2');
};

/**
 *
 * @param {*} event
 * @param {*} me
 */
export const triggerContextMenu = (event, me) => {
    var rightClickEnabled = me
        .closest('.hasRightClick')
        .find('.rightClickOption')
        .hasClass('rightClickEnabled');
    if (!rightClickEnabled) {
        var rightClickOption = me.closest('.hasRightClick').find('.rightClickOption');
        if (!rightClickOption.hasClass('rightClickEnabled') && rightClickOption.val() !== '') {
            var rcOption = JSON.parse(rightClickOption.val());
            rightClickOption.closest('.hasRightClick').contextmenu(rcOption);
            rightClickOption.addClass('rightClickEnabled');
        }
    }

    var tmpE = $.event;
    tmpE.type = 'contextmenu';

    if (event.pageX !== undefined) {
        tmpE.pageX = event.pageX;
    } else {
        tmpE.pageX = event.clientX;
    }

    if (event.pageY !== undefined) {
        tmpE.pageY = event.pageY - 10;
    } else {
        tmpE.pageY = event.clientY - 10;
    }

    me.trigger(tmpE);
};

/**
 *
 */
export const reload = () => {
    relocate('__reload');
};

/**
 *
 * @param {*} newLocation
 * @param {*} newTarget
 */
export const relocate = (newLocation, newTarget) => {
    newLocation = undefined === newLocation ? './' : newLocation;
    newTarget = newTarget ? true : false;
    newLocation = newLocation[0] === '?' ? '/' + newLocation : newLocation;

    if ('__reload' === newLocation) {
        return window.location.reload();
    }

    if (newTarget) {
        window.open(newLocation, '_blank');
        void 0;
    } else {
        window.location.href = newLocation;
    }
};

/**
 *
 * @param {*} id
 */
export const remove = (id) => {
    if (exists(id))
        $('#' + id)
            .empty()
            .remove();
};

/**
 *
 * @param {*} wrapper
 * @param {*} loopClass
 * @param {*} order
 * @param {*} attr
 */
export const sortDiv = (wrapper, loopClass, order, attr) => {
    var $wrapper = wrapper;
    $wrapper
        .find(loopClass)
        .sort(function (a, b) {
            if (order === 'desc') {
                return +b.dataset[attr.toLowerCase()] - +a.dataset[attr.toLowerCase()];
            } else {
                return +a.dataset[attr.toLowerCase()] - +b.dataset[attr.toLowerCase()];
            }
        })
        .appendTo($wrapper);
};

/**
 *
 * @param {*} me
 */
export const submitFormReconnexion = (me) => {
    if (me.keyCode === 13) {
        $('#loginForm').submit();
    }
};

/**
 *
 * @param {*} toAnimate
 */
export const toggleDisplay = (toAnimate) => {
    $('#' + toAnimate).click(function () {
        $('#' + toAnimate).hide();
    });
    var display = !('none' === $('#' + toAnimate).css('display'));
    if (display) $('#' + toAnimate).fadeOut();
    else $('#' + toAnimate).fadeIn();

    MyFacture.customForm();
};

/**
 *
 * @param {*} element
 */
export const toogle = (element) => {
    var selector = $(element).attr('toggle');
    var call = $(element).attr('call');
    $(selector).each(function () {
        var id = '#' + $(this).attr('id');
        var display = $(id + ' .toggleContent').css('display') != 'none';
        if (display) {
            if ($(id + ' .toggleContent')) $(id + ' .toggleContent').slideUp(200);
            $(id + ' .toggleCursor').removeClass('close');
            $(id + ' .toggleCursor').addClass('open');
        } else {
            if ($(id + ' .toggleContent')) $(id + ' .toggleContent').slideDown();
            $(id + ' .toggleCursor').removeClass('open');
            $(id + ' .toggleCursor').addClass('close');
            MyFacture.customForm();
        }
    });
    eval(call);
};

/**
 *
 * @param {*} string
 */
export const ucfirst = (string) => {
    return string && string[0].toUpperCase() + string.slice(1);
};
/**
 * Detect if device can be considerate like desktop (not too small and not a tablet)
 *  - return true if is not too small and not a tablet
 *  - return false else
 *
 *  minWidth is based on min-width define in styleguide : _layout.scss html>body div.global
 *  regExTablet test if device is a tablet
 */
export const isDesktop = () => {
    const minWidth = 1024;
    const regExTablet =
        /((ipad|tablet|playbook|kindle|silk)|(android(?!.*mobile))|(windows(?!.*phone)(.*touch)))/;

    const isTablet = regExTablet.test(navigator.userAgent.toLowerCase());
    const isTooSmallSize = window.innerWidth < minWidth;

    return !isTablet && !isTooSmallSize;
};

/**
 * Throttling is a technique in which,
 * no matter how many times the user fires the event,
 * the attached function will be executed only once in a given time interval
 *
 * @param {*} delay
 * @param {*} fn
 * @returns {Function}
 */
export const throttled = (delay, fn) => {
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) return;
        lastCall = now;
        return fn(...args);
    };
};

/**
 * Debouncing is a technique in which,
 * no matter how many times the user fires the event,
 * the attached function will be executed only after the specified time once the user stops firing the event
 *
 * @param {*} delay
 * @param {*} fn
 * @returns {Function}
 */
export const debounced = (delay, fn) => {
    let timerId;
    return function (...args) {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(() => {
            fn(...args);
            timerId = null;
        }, delay);
    };
};

export const replaceVarInString = (string, data) => {
    // Create regex using the keys of the replacement object.
    var regex = new RegExp(':(' + Object.keys(data).join('|') + ')', 'g');

    // Replace the string by the value in object
    return string.replace(regex, (m, $1) => data[$1] || m);
};
